import React from "react";
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/Footer";
import BuiltEmpower from "@/components/About/BuiltEmpower";
import ExpertFinancial from "@/components/About/ExpertFinancial";
import ValuesShape from "@/components/About/ValuesShape";
import { useTranslation } from "@/translations/TranslationContext";
import "@/components/About/About.css";

const About = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <Header />
      <div className="banner innerbanner mb150_75 banabout">
        <div className="container">
          <div className="inerban">
            <span className="chips">{t.about.banner.chips}</span>
            <h1>{t.about.banner.title}</h1>
            <p className="text24">
              {t.about.banner.subtitle}
            </p>
          </div>
        </div>
      </div>
      <BuiltEmpower />
      <ExpertFinancial />
      <ValuesShape />
      <Footer />
    </>
  );
};

export default About;
